"use client";

import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function BookCardSkeleton() {
  return (
    <Card className="h-full flex flex-col justify-between p-5 border-border/50 shadow-sm bg-card animate-pulse">
      <div className="flex items-start gap-4 mb-6">
        <div className="w-12 h-12 rounded-xl bg-muted shrink-0" />
        
        <div className="flex-1 space-y-2 py-1">
          <div className="h-5 bg-muted rounded-md w-3/4" />
          <div className="h-4 bg-muted rounded-md w-1/2" />
        </div>
      </div>

      <div className="mt-auto space-y-3">
        <div className="flex items-center justify-between">
          <div className="h-4 bg-muted rounded-md w-16" />
          <div className="h-4 bg-muted rounded-md w-8" />
        </div>
        <div className="h-2 w-full bg-muted rounded-full" />
      </div>
    </Card>
  );
}

export function BookGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-dashboard-1 sm:grid-cols-dashboard-2 lg:grid-cols-dashboard-3 xl:grid-cols-dashboard-4 gap-4 sm:gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ animationDelay: `${i * 100}ms` }} className="animate-pulse">
          <BookCardSkeleton />
        </div>
      ))}
    </div>
  );
}